import { Divider } from '@mui/material';
import { TripBenefit } from '../../../gql/graphql';
import { RoomDetail } from '../types';

interface Props {
  tripBenefits: TripBenefit[] | undefined;
  roomDetails: RoomDetail[];
}

const calculateTotalPrice = (roomDetails: RoomDetail[]) => {
  return roomDetails.reduce((total, room) => total + room.pricePerRoom, 0);
};

const PaymentDetailsContent: React.FC<Props> = ({
  tripBenefits,
  roomDetails,
}) => {
  const totalPrice = calculateTotalPrice(roomDetails);

  return (
    <div>
      <div className="bg-neutral-20 rounded-lg mt-6">
        {roomDetails.map((room, index) => (
          <div className="flex justify-between p-4" key={index}>
            <div className="flex">
              <img
                className="rounded-lg w-12 h-12"
                src={room.imageUrl || 'https://via.placeholder.com/48'}
                alt="Room"
              />
              <div className="flex flex-col justify-center ml-4">
                <span className="text-neutral-800 font-semibold">
                  Guest {index + 1}
                </span>
                <span className="text-neutral-500 text-sm">
                  {room.typeName}
                </span>
              </div>
            </div>
            <div className="flex items-center">
              <span className="text-neutral-800">
                B{room.pricePerRoom.toLocaleString()}
              </span>
            </div>
          </div>
        ))}
        <div className="mt-4 p-4">
          <Divider />
          <div className="my-4 flex flex-col text-neutral-800">
            <div className="flex justify-between">
              <span>Subtotal</span>
              <span>B{totalPrice.toLocaleString()}</span>
            </div>
            {/* Uncomment if additional fees are needed */}
            {/* <div className="mt-4 flex justify-between">
              <span>Santtai service fee</span>
              <span>B10,000</span>
            </div>
            <div className="mt-4 flex justify-between">
              <span>Taxes</span>
              <span>B5,000</span>
            </div> */}
          </div>
          <Divider />
          <div className="mt-4 flex justify-between text-neutral-800">
            <span className="text-xl font-semibold">Total</span>
            <span className="text-xl font-semibold">
              B{totalPrice.toLocaleString()}
            </span>
          </div>
        </div>
      </div>
      <div className="mt-6 p-4">
        <div className="flex flex-col">
          <span className="text-sm text-neutral-800 font-semibold">
            Trip included
          </span>
          <span className="mt-2 text-xs text-neutral-500">
            {tripBenefits
              ?.filter(benefit => benefit.isInclusion)
              .map(benefit => benefit.benefitName)
              .join(' • ')}
          </span>
        </div>
        <div className="mt-4 flex flex-col">
          <span className="text-sm text-neutral-800 font-semibold">
            Trip excluded
          </span>
          <span className="mt-2 text-xs text-neutral-500">
            {tripBenefits
              ?.filter(benefit => !benefit.isInclusion)
              .map(benefit => benefit.benefitName)
              .join(' • ')}
          </span>
        </div>
        <div className="mt-4 flex flex-col">
          <span className="text-sm text-neutral-800 font-semibold">
            Cancellation Policy
          </span>
          <span className="mt-2 text-xs text-neutral-500">
            This booking is non-refundable. Once confirmed, payments are
            non-refundable under any circumstances. Please review your plans
            carefully before booking. For any inquiries, contact our support
            team.
          </span>
        </div>
      </div>
    </div>
  );
};

export default PaymentDetailsContent;
